// The quick search's query — what the header's search bar asks while the
// person types, and what Home's Basic search asks for its suggestions. One
// rule in one place, so the two lists can never disagree.
//
// classifyTerm picks the cheapest query for what was typed:
//   'key'  — the part before the first dash is a real project key OR a PREFIX
//            of one ("YED", "YED2401", "YED2401-14"): search the issue_key
//            column ONLY (`key ~`, so a partial still surfaces its siblings).
//   'text' — anything else: key + summary (the only path paying the per-row
//            EAV `text ~` cost).
// A summary part number that only LOOKS key-shaped ("FT200-0001") prefixes no
// project, so it still searches summaries. projectKeys is a Set of
// lower-cased keys, or null until it loads (→ the safe key+summary path).

export const QUICK_SEARCH_FIELDS = 'summary,status,issuetype,assignee,priority,project';
export const QUICK_SEARCH_DEBOUNCE_MS = 300;

export function escapeJql(str) {
  return String(str).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

export function classifyTerm(term, projectKeys) {
  if (!projectKeys || !projectKeys.size) return 'text';
  const prefix = String(term).split('-')[0].toLowerCase();
  if (!prefix) return 'text';
  for (const k of projectKeys) {
    if (k.startsWith(prefix)) return 'key';
  }
  return 'text';
}

// Key path: NO explicit ORDER BY — a broad prefix matches many rows and
// `ORDER BY updated` is a per-row EAV subquery; the engine's default order
// (newest first) needs none. The text path keeps updated-order.
export function quickSearchJql(term, projectKeys) {
  const esc = escapeJql(String(term).trim());
  return classifyTerm(term.trim(), projectKeys) === 'key'
    ? `key ~ "${esc}"`
    : `(key ~ "${esc}" OR text ~ "${esc}") ORDER BY updated DESC`;
}

// The project keys the classifier needs, lower-cased, from GET /api/projects.
export async function loadProjectKeySet(api) {
  const data = await api.getProjects();
  const values = Array.isArray(data) ? data : (data?.values || []);
  const set = new Set(values.map((p) => String(p?.key || '').toLowerCase()).filter(Boolean));
  return set.size ? set : null;
}
